<p-panelMenu [model]="menuItems" [multiple]="false"></p-panelMenu>
